import { defineEntity, custom } from './_helpers.js';

export default defineEntity('dataSubjectRequest', {
    applicantReceipt: custom({ scope: 'state' }),
    deadlineReminder: custom({ scope: 'state' }),
    deadlineOverdue: custom({ scope: 'state' }),
});
